import React, { useEffect } from 'react';

const REZRATE_VIDEO_WINDOW_TARGET = 'rezrate-video';

const ZoomRoom = () => {
  useEffect(() => {
    const zoomRoom = localStorage.getItem('zoomUrl');
    if (!zoomRoom) {
      console.info('[RezRATE][meeting-window]', 'zoom-room.missing-url');
      return;
    }

    let popupWindow = null;
    try {
      popupWindow = window.open(zoomRoom, REZRATE_VIDEO_WINDOW_TARGET);
      console.info('[RezRATE][meeting-window]', 'zoom-room.open', {
        target: REZRATE_VIDEO_WINDOW_TARGET,
        opened: !!popupWindow,
      });
    } catch (error) {
      popupWindow = null;
      console.info('[RezRATE][meeting-window]', 'zoom-room.open.error', {
        message: error && error.message ? error.message : 'unknown',
      });
    }

    // Fallback to a fresh tab if the named-window open is blocked.
    if (!popupWindow) {
      window.open(zoomRoom, '_blank', 'noopener,noreferrer');
    }
  }, []);
  return <div></div>;
};

export default ZoomRoom;
